export default "__VITE_ASSET__CkZqsiFB__"